(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-store/assets/javascripts/hooks/use-search-results.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-store/assets/javascripts/hooks/use-search-results.js');
"use strict";


const {
  useState
} = React;
const {
  useSearchParams
} = svs.components.casino_react.hooks;
const {
  useGetSearchResultQuery
} = svs.components.casino_react.casinoStore.endpoints.searchApi;
const {
  constants: {
    DefaultNumberOfCasinoGridItems
  }
} = svs.components.casino_react.common;
const getShouldSkipGamesFetch = _ref => {
  let {
    searchQuery,
    tags,
    providers,
    categories,
    skipGamesSearch
  } = _ref;
  const emptyParams = !searchQuery && (tags === null || tags === void 0 ? void 0 : tags.length) === 0 && (providers === null || providers === void 0 ? void 0 : providers.length) === 0 && (categories === null || categories === void 0 ? void 0 : categories.length) === 0;
  const noInputs = !searchQuery && !(tags !== null && tags !== void 0 && tags.length) && !(providers !== null && providers !== void 0 && providers.length) && !(categories !== null && categories !== void 0 && categories.length);
  return emptyParams || noInputs || skipGamesSearch;
};

const useSearchResults = function () {
  let {
    fetchCount = DefaultNumberOfCasinoGridItems * 3,
    fetchOffset = 0,
    skipGamesSearch = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const [count] = useState(fetchCount);
  const [offset, setOffset] = useState(fetchOffset);
  const {
    q: queryString,
    tags,
    categories,
    providers,
    sorting
  } = useSearchParams();
  const shouldSkipFetch = getShouldSkipGamesFetch({
    searchQuery: queryString,
    tags,
    providers,
    categories,
    skipGamesSearch
  });
  const {
    data,
    isLoading,
    error,
    isFetching
  } = useGetSearchResultQuery({
    searchQuery: queryString,
    tags,
    providers,
    categories,
    count,
    offset,
    sorting
  }, {
    skip: shouldSkipFetch,
    selectFromResult: result => {
      if (shouldSkipFetch || !(result !== null && result !== void 0 && result.data)) {
        return {
          data: {
            games: null,
            error: null,
            totalCount: null
          }
        };
      }
      return result;
    }
  });
  return {
    games: data === null || data === void 0 ? void 0 : data.games,
    totalGamesCount: data === null || data === void 0 ? void 0 : data.totalCount,
    error,
    latestSearchQuery: queryString,
    offset,
    setOffset,
    isLoading,
    isFetching
  };
};
setGlobal('svs.components.casino_react.casinoStore.hooks.useSearchResults', useSearchResults);

 })(window);